import React, { useState } from 'react';
import { Modal, Box, Typography, Button, TextField, CircularProgress, Alert, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
// **FIX:** Import the required API functions
import { uploadCalendarFile, addCalendarTableEntry } from '../../services/adminApiClient';
import { v4 as uuidv4 } from 'uuid';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

// **FIX:** Correctly destructure all props
export default function UploadModal({ open, onClose, customer, onSubmitSuccess }) {
    const [file, setFile] = useState(null);
    const [calendarYear, setCalendarYear] = useState('');
    const [status, setStatus] = useState('Active');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };
    
    const handleSubmit = async () => {
        // **FIX:** The 'fileName' variable is derived from the 'file' state object
        const fileName = file ? file.name : '';

        if (!file || !calendarYear || !customer || !fileName) {
            setError('Please fill all required fields and select a file.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        try {
            // Step 1: Upload the file
            await uploadCalendarFile(file);

            // Step 2: Create payload for the table entry
            const payload = {
                calendar_id: uuidv4(),
                calendar_year: parseInt(calendarYear, 10),
                client_name: customer.ClientName,
                client_code: customer.ClientCode,
                file_name: fileName,
                status: status,
                timestamp: new Date().toISOString(),
                uploaded_by: 'x372184', // Placeholder
                last_updated_by: 'x372184' // Placeholder
            };
            
            // Step 3: Add the entry to the table
            await addCalendarTableEntry(payload);

            // Step 4: Notify parent of success
            if (onSubmitSuccess) {
                onSubmitSuccess();
            }
        } catch (e) {
            setError(e.message || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">Upload New Calendar</Typography>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                <Box sx={{ mt: 2 }}>
                    <TextField label="Client Name" value={customer ? customer.ClientName : ''} disabled fullWidth margin="normal" />
                    <TextField label="Client Code" value={customer ? customer.ClientCode : ''} disabled fullWidth margin="normal" />
                    <TextField
                        label="Calendar Year"
                        value={calendarYear}
                        onChange={(e) => setCalendarYear(e.target.value)}
                        required
                        fullWidth
                        margin="normal"
                        type="number"
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                    <Button variant="contained" component="label" fullWidth sx={{ mt: 1 }}>
                        Choose File
                        <input type="file" hidden onChange={handleFileChange} />
                    </Button>
                    {file && <Typography sx={{ mt: 1 }}>Selected: {file.name}</Typography>}
                </Box>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

